export default __webpack_public_path__ + "static/media/calendar-icon-blue.0c63f790.svg";